import { fontService } from '@/_services';
import { API_ROOT } from '@/config';

const state = {
  items: [],
  loaded: false,
  fontName: null,
};

const actions = {
  load({ commit, dispatch }) {
    return fontService.getAll().then((response) => {
      commit('updateData', response.data.results);
      dispatch('injectFonts');
    });
  },
  injectFonts({ commit, rootState, state }) {
    if (state.loaded === true) {
      return;
    }

    // Insert server's css fonts
    const institution = rootState.account.user.profile.institution.pk;
    const css = `${API_ROOT}/institution_fonts/${institution}/fonts.css`;
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.type = 'text/css';
    style.href = css;
    style.appendChild(document.createTextNode(''));
    document.head.appendChild(style);

    // Create Quill styles
    const fontstyle = document.createElement('style');

    // Define default font
    if (state.items.length) {
      // Get default font if defined, or use first one
      const defaultFont = state.items.filter((font) => font.is_institution_default)[0];

      fontstyle.innerHTML += `
                .ql-container {
                    font-family: '${defaultFont.font_family}';
                }
            `;
    }

    state.items.forEach((item, index) => {
      // Customize intro text editor font selector
      fontstyle.innerHTML += `
            .ql-font-${item.font_family} {
                font-family: '${item.font_family}', sans-serif
            }
            .ql-font span[data-value="${item.font_family}"]::before{
                display: none;
            }
            .ql-font span[data-value="${item.font_family}"]::after{
                /* font-family: "${item.font_family}"; */
                content: "${item.display_name}" !important;
            }
            `;
    });
    document.head.appendChild(fontstyle);

    commit('updateLoaded', true);
  },
  // fetchData({ commit }) {
  //     productService.getItems().then(response => {
  //         console.log('Products', response)
  //         commit('updateData', response.data.results)
  //     })
  // }
  injectFontsAnonymousUser({ commit, rootState, state }, institutionPk) {
    if (state.loaded === true) {
      return;
    }

    // Insert server's css fonts;
    const css = `${API_ROOT}/institution_fonts/${institutionPk}/fonts.css`;
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.type = 'text/css';
    style.href = css;
    style.appendChild(document.createTextNode(''));
    document.head.appendChild(style);

    // Create Quill styles
    const fontstyle = document.createElement('style');

    // Define default font
    if (state.items.length) {
      // Get default font if defined, or use first one
      const defaultFont = state.items.filter((font) => font.is_institution_default)[0];
      const useFont = defaultFont || state.items[0];
      fontstyle.innerHTML += `
                .ql-container {
                    font-family: '${useFont.font_family}';
                }
            `;
    }

    state.items.forEach((item, index) => {
      // Customize intro text editor font selector
      fontstyle.innerHTML += `
            .ql-font-${item.font_family} {
                font-family: '${item.font_family}', sans-serif
            }
            .ql-font span[data-value="${item.font_family}"]::before{
                display: none;
            }
            .ql-font span[data-value="${item.font_family}"]::after{
                /* font-family: "${item.font_family}"; */
                content: "${item.display_name}" !important;
            }
            `;
    });
    document.head.appendChild(fontstyle);

    commit('updateLoaded', true);
  },
  updateFontData({ commit }, items) {
    commit('updateData', items);
  },
};

const mutations = {
  // A no-op mutation must be added to serve as a trigger for a reset.
  reset: () => { },
  updateData(state, items) {
    // Put default font first
    state.items = items.sort((a, b) => {
      if (a.is_institution_default) return -1;
      if (b.is_institution_default) return 1;
      return 0;
    });
  },
  updateLoaded(state, status) {
    state.loaded = status;
  },
  updateFontName(state, name) {
    state.fontName = name;
  },
};

export const fonts = {
  namespaced: true,
  state,
  actions,
  mutations,
};
